if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      const self = this;

      this.form = this.querySelector('form');
      this.formsAdditional = document.querySelectorAll(".product-form-additional form");
      this.form?.querySelector('[name=id]') ? this.form.querySelector('[name=id]').disabled = false : "";
      this.form?.addEventListener('submit', function(e) {
        self.onSubmitHandler(e, this);
      });
      this.formsAdditional.forEach(form => {
        form.addEventListener('submit', function(e) {
          self.onSubmitHandler(e, this);
        });
      });
    }

    onSubmitHandler(evt, formEl) {
      evt.preventDefault();
      const submitBtn = formEl.querySelector('[type="submit"]');
      const isMixIt = document.querySelector("[data-template='product.on_bundle-xl']") || document.querySelector("[data-template='product.on_bundle-xl_dynamic-price']");
      const hasGifts = document.querySelector("GIFT PRODUCT PAGE ID");
      
      if (submitBtn.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitBtn.setAttribute('aria-disabled', true);
      submitBtn.classList.add('loading');
      formEl.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (isMixIt) {
        const { items, price } = window.mixitGetBundleData();
        window.mixitAtcView.createHiddenInputs(items, price);
      }

      if (hasGifts) {
        const formInputs = `
          <input class="temp-form-input" type="hidden" name="items[1]id" value="GIFT ID">
          <input class="temp-form-input" type="hidden" name="items[1]properties[_Gifted]" value="true">
          <input class="temp-form-input" type="hidden" name="items[1]properties[_Identifier]" value="${Math.ceil(Math.random() * 100000)}">
        `;

        const giftInputs = formEl.querySelectorAll("[name*='items[1]'");
        giftInputs?.forEach(inputEl => inputEl.remove());
        
        formEl.insertAdjacentHTML("beforeend", formInputs); 
      }

      const formData = new FormData(formEl);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(async response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          await window.giftSectionRemoveGifts();
          window.slideCartToggle({ manuallyOpened: false });

          const addToCartEvent = new CustomEvent('productAddedToCart', {
            detail: response
          });
          document.dispatchEvent(addToCartEvent);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
          formEl.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (isMixIt) {
            window.mixitAtcView.removeHiddenInputs();
            
            const mixitData = window.mixitResetData();

            window.mixitAtcView.toggleBtn(mixitData.menus, mixitData.bundleItems);
            window.mixitUpdateMenu(mixitData.menus, mixitData.bundleItems);
            window.mixitUpdateOverview(mixitData.menus);
            window.mixitUpdateDetails(mixitData.menus, mixitData.bundleItems);
            window.mixitToggleDetails({ close: true });
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
